import React from 'react';
import SelectionCheckbox from '../../components/selection-checkbox';

/**
 * Barre flottante de sélection multiple : affecter à un camion (ouvre la
 * modale d'affectation), replanifier, renvoyer au puits, vider la sélection
 */
export default function SelectionBar({
  selectedDeliveries,
  trucks,
  onAssign,
  onReschedule,
  onReturnToPool,
  onUnassign,
  onClear,
  isBusy,
}) {
  const count = selectedDeliveries.length;
  if (count === 0) return null;
  const hasAssigned = selectedDeliveries.some((d) => d.vehicleId);

  return (
    <div className="ta-selection-bar">
      <SelectionCheckbox
        checked
        onChange={onClear}
        title="Vider la sélection"
      />
      <span className="ta-selection-bar__count">
        {count} sélectionnée{count > 1 ? 's' : ''}
      </span>
      <span className="ta-divider" />

      <button
        type="button"
        className="ta-link ta-link--strong"
        onClick={onAssign}
        disabled={isBusy || trucks.length === 0}
      >
        Affecter à un camion
      </button>

      <button
        type="button"
        className="ta-link ta-link--strong"
        onClick={onReschedule}
        disabled={isBusy}
      >
        Replanifier
      </button>
      <button
        type="button"
        className="ta-link ta-link--strong"
        onClick={onUnassign}
        disabled={isBusy || !hasAssigned}
        title={
          hasAssigned
            ? 'Remettre dans « À placer »'
            : 'Aucune commande affectée'
        }
      >
        Désaffecter
      </button>
      <button
        type="button"
        className="ta-link ta-link--strong"
        onClick={onReturnToPool}
        disabled={isBusy}
      >
        Renvoyer au puits
      </button>
      <span className="ta-divider" />
      <button
        type="button"
        className="ta-icon-btn ta-icon-btn--dark"
        onClick={onClear}
        title="Vider la sélection"
      >
        ✕
      </button>
    </div>
  );
}
